import NAME from "./constants";

export const RESET_ALL = NAME + "/RESET_ALL";

export const GET_ALL_COURSES = NAME + "/GET_ALL_COURSES";
export const GET_ALL_COURSES_REJECTED = NAME + "/GET_ALL_COURSES_REJECTED";
export const GET_ALL_COURSES_FULFILLED = NAME + "/GET_ALL_COURSES_FULFILLED";

// COURSE
export const GET_COURSE = NAME + "/GET_COURSE";
export const GET_COURSE_REJECTED = NAME + "/GET_COURSE_REJECTED";
export const GET_COURSE_FULFILLED = NAME + "/GET_COURSE_FULFILLED";

export const CREATE_COURSE = NAME + "/CREATE_COURSE";
export const CREATE_COURSE_REJECTED = NAME + "/CREATE_COURSE_REJECTED";
export const CREATE_COURSE_FULFILLED = NAME + "/CREATE_COURSE_FULFILLED";

export const UPDATE_COURSE = NAME + "/UPDATE_COURSE";
export const UPDATE_COURSE_REJECTED = NAME + "/UPDATE_COURSE_REJECTED";
export const UPDATE_COURSE_FULFILLED = NAME + "/UPDATE_COURSE_FULFILLED";

export const DELETE_COURSE = NAME + "/DELETE_COURSE";
export const DELETE_COURSE_REJECTED = NAME + "/DELETE_COURSE_REJECTED";
export const DELETE_COURSE_FULFILLED = NAME + "/DELETE_COURSE_FULFILLED";

export const DUPLICATE_COURSE = NAME + "/DUPLICATE_COURSE";
export const DUPLICATE_COURSE_REJECTED = NAME + "/DUPLICATE_COURSE_REJECTED";
export const DUPLICATE_COURSE_FULFILLED = NAME + "/DUPLICATE_COURSE_FULFILLED";

export const EXPORT_COURSE = NAME + "/EXPORT_COURSE";
export const EXPORT_COURSE_REJECTED = NAME + "/EXPORT_COURSE_REJECTED";
export const EXPORT_COURSE_FULFILLED = NAME + "/EXPORT_COURSE_FULFILLED";

export const IMPORT_COURSE = NAME + "/IMPORT_COURSE";
export const IMPORT_COURSE_REJECTED = NAME + "/IMPORT_COURSE_REJECTED";
export const IMPORT_COURSE_FULFILLED = NAME + "/IMPORT_COURSE_FULFILLED";

export const GET_COURSE_TREE = NAME + "/GET_COURSE_TREE";
export const GET_COURSE_TREE_REJECTED = NAME + "/GET_COURSE_TREE_REJECTED";
export const GET_COURSE_TREE_FULFILLED = NAME + "/GET_COURSE_TREE_FULFILLED";

export const RESET_COURSE = NAME + "/RESET_COURSE";

// MODULES
export const GET_MODULES = NAME + "/GET_MODULES";
export const GET_MODULES_REJECTED = NAME + "/GET_MODULES_REJECTED";
export const GET_MODULES_FULFILLED = NAME + "/GET_MODULES_FULFILLED";

export const CREATE_MODULE = NAME + "/CREATE_MODULE";
export const CREATE_MODULE_REJECTED = NAME + "/CREATE_MODULE_REJECTED";
export const CREATE_MODULE_FULFILLED = NAME + "/CREATE_MODULE_FULFILLED";

export const UPDATE_MODULE = NAME + "/UPDATE_MODULE";
export const UPDATE_MODULE_REJECTED = NAME + "/UPDATE_MODULE_REJECTED";
export const UPDATE_MODULE_FULFILLED = NAME + "/UPDATE_MODULE_FULFILLED";

export const DELETE_MODULE = NAME + "/DELETE_MODULE";
export const DELETE_MODULE_REJECTED = NAME + "/DELETE_MODULE_REJECTED";
export const DELETE_MODULE_FULFILLED = NAME + "/DELETE_MODULE_FULFILLED";

// ACTIVITIES
export const GET_ACTIVITIES = NAME + "/GET_ACTIVITIES";
export const GET_ACTIVITIES_REJECTED = NAME + "/GET_ACTIVITIES_REJECTED";
export const GET_ACTIVITIES_FULFILLED = NAME + "/GET_ACTIVITIES_FULFILLED";

export const GET_ACTIVITY = NAME + "/GET_ACTIVITY";
export const GET_ACTIVITY_REJECTED = NAME + "/GET_ACTIVITY_REJECTED";
export const GET_ACTIVITY_FULFILLED = NAME + "/GET_ACTIVITY_FULFILLED";

export const CREATE_ACTIVITY = NAME + "/CREATE_ACTIVITY";
export const CREATE_ACTIVITY_REJECTED = NAME + "/CREATE_ACTIVITY_REJECTED";
export const CREATE_ACTIVITY_FULFILLED = NAME + "/CREATE_ACTIVITY_FULFILLED";

export const UPDATE_ACTIVITY = NAME + "/UPDATE_ACTIVITY";
export const UPDATE_ACTIVITY_REJECTED = NAME + "/UPDATE_ACTIVITY_REJECTED";
export const UPDATE_ACTIVITY_FULFILLED = NAME + "/UPDATE_ACTIVITY_FULFILLED";

export const DELETE_ACTIVITY = NAME + "/DELETE_ACTIVITY";
export const DELETE_ACTIVITY_REJECTED = NAME + "/DELETE_ACTIVITY_REJECTED";
export const DELETE_ACTIVITY_FULFILLED = NAME + "/DELETE_ACTIVITY_FULFILLED";

export const RESET_MODULES_AND_ACTIVITIES = NAME + "/RESET_MODULES_AND_ACTIVITIES";
export const RESET_ACTIVITY = NAME + "/RESET_ACTIVITY";